import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";
import formatZdate from "../../../utils/formatZdate";

import MasterFinyearEditForm from "./MasterFinyearEditForm";

const getFinyearOneAPI = `${process.env.REACT_APP_API_URL}api/finyear`;

const MasterFinyearEdit = ({ finyearData, buttonConfig, selectedItemId, isButtonClicked }) => {
  const schema = z.object({
    fin_year_name: z.string().nonempty(),
    fin_year_short_name: z.string(),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
    status: z.boolean().or(z.string()),
    member: z.optional(z.number()).or(z.nullable(z.number())),
  });

  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("subscriberToken")
    ? sessionStorage.getItem("subscriberToken")
    : sessionStorage.getItem("token")}`,
    "Content-Type": "application/json",
  };

  const form = useForm({
    defaultValues: async () => {
      const getSegment = `${getFinyearOneAPI}/${selectedItemId}`;
      const res = await axios.get(getSegment, { headers });
      const segment = res.data.data;
      return {
        fin_year_name: segment.fin_year_name,
        fin_year_short_name: segment.fin_year_short_name,
        status: segment.status ? "true" : "false",
        eff_start_date: segment.eff_start_date,
        eff_end_date: segment.eff_end_date,
        member: segment.member,
      };
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterFinyearEditForm
      finyearData={finyearData}
      form={form}
      segmentName={buttonConfig.name}
      editHandler={buttonConfig.editHandler}
      closeHandler={buttonConfig.closeEditModal}
      selectedItemId={selectedItemId}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterFinyearEdit;
